var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "subpage-head" }, [
      _c("div", { staticClass: "container" }, [
        _c("h1", [
          _vm._v(
            _vm._s(_vm.item.id ? "Edit" : "Create") + " " + _vm._s(_vm.entity)
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "login-reg" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("div", { staticClass: "log-box main" }, [
            _c(
              "form",
              {
                staticClass: "gen-form",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.saveProfile($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-row" }, [
                  _c("label", [_vm._v("Username")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.username,
                        expression: "item.username"
                      }
                    ],
                    attrs: { type: "text", readonly: _vm.item.id },
                    domProps: { value: _vm.item.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "username", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c("label", [_vm._v("Email Address")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.item.email,
                        expression: "item.email"
                      }
                    ],
                    attrs: { type: "email" },
                    domProps: { value: _vm.item.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.item, "email", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row split" }, [
                  _c("div", [
                    _c("label", [_vm._v("First Name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.firstname,
                          expression: "item.firstname"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.item.firstname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "firstname", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [_vm._v("Last Name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.lastname,
                          expression: "item.lastname"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.item.lastname },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "lastname", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row split" }, [
                  _c("div", [
                    _c("label", [_vm._v("Password")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.newPassword,
                          expression: "item.newPassword"
                        }
                      ],
                      attrs: { type: "password" },
                      domProps: { value: _vm.item.newPassword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "newPassword", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", [_vm._v("Confirm Password")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.confirmPassword,
                          expression: "item.confirmPassword"
                        }
                      ],
                      attrs: { type: "password" },
                      domProps: { value: _vm.item.confirmPassword },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.item,
                            "confirmPassword",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row split" }, [
                  _c("div", [
                    _c("br"),
                    _vm._v(" "),
                    _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.admin,
                            expression: "item.admin"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.item.admin)
                            ? _vm._i(_vm.item.admin, null) > -1
                            : _vm.item.admin
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.item.admin,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(_vm.item, "admin", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.item,
                                    "admin",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.item, "admin", $$c)
                            }
                          }
                        }
                      }),
                      _c("em"),
                      _vm._v("\n                Administrator\n              ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("br"),
                    _vm._v(" "),
                    _c("label", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.hasPpatt,
                            expression: "item.hasPpatt"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.item.hasPpatt)
                            ? _vm._i(_vm.item.hasPpatt, null) > -1
                            : _vm.item.hasPpatt
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.item.hasPpatt,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.item,
                                    "hasPpatt",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.item,
                                    "hasPpatt",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.item, "hasPpatt", $$c)
                            }
                          }
                        }
                      }),
                      _c("em"),
                      _vm._v(
                        "\n                Has access to PPATT\n              "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row form-row-photo" }, [
                  _c("label", [_vm._v("Photo")]),
                  _vm._v(" "),
                  _vm.item.media
                    ? _c("img", {
                        attrs: {
                          src: _vm.photoLinkR(_vm.item.media, 256, 256, "Fit"),
                          alt: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.media
                    ? _c(
                        "button",
                        {
                          staticClass: "del-file",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removePhoto($event)
                            }
                          }
                        },
                        [_vm._v("Remove photo")]
                      )
                    : _c("input", {
                        ref: "photoUpload",
                        attrs: { type: "file" }
                      })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-act" }, [
                  _c("button", { staticClass: "lbtn" }, [
                    _vm._v(_vm._s(_vm.item.id ? "Update" : "Create"))
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm.item.id
            ? _c("user-package", {
                attrs: { item: _vm.item },
                on: {
                  update: function($event) {
                    return _vm.$emit("update")
                  },
                  save: function($event) {
                    return _vm.$emit("save")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }